import { render, staticRenderFns } from "./DistrictCreateOrUpdate.vue?vue&type=template&id=526defad&"
import script from "./DistrictCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./DistrictCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports